/**
 * Copyright (C) 2019 User X, LLC http://whoisuserx.com <info@userx.co>
 *
 * This program is the intellectual property of User X, LLC. You may
 * not redistribute and/or modify it without written consent by controlling
 * entities of User X, LLC.
 *
 * You should have received a copy of our Web Developer Agreement which
 * outlines proper use and distribution of this program. If you did not
 * please email info@userx.co to request your copy.
 */
/**
 * File created by John M. Woodcock < john@userx.co >
 * on 10/26/2022
 * for support.userx.co
 */

import {createContext, useCallback, useContext, useRef, useState} from "react";
import useLocalStorage from "../_hooks/useLocalStorage";

export const UserContext = createContext();

export const UserProvider = ({children}) => {
    const [userContext, setUserContext] = useLocalStorage('uxUser', {
        isLoggedIn: false,
        contact:    null,
        dashboard:  null,
        filters:    []
    });
    const itemsListCompaniesRef = useRef([]);
    const [itemsListCompaniesVersion, setItemsListCompaniesVersion] = useState(0);

    const getCompaniesFromItems = useCallback((items = []) => {
        const map = new Map();
        for (const it of items) {
            if (it && it.company_id && it.company_name) {
                map.set(it.company_id, it.company_name);
            }
        }

        const companies = Array.from(map.entries())
        .map(([id, name]) => ({ id, name }))
        .sort((a, b) => a.name.localeCompare(b.name));

        const cached = itemsListCompaniesRef.current;
        const same =
                  cached.length === companies.length &&
                  cached.every((c, i) => c.id === companies[i].id && c.name === companies[i].name);

        if (!same) {
            itemsListCompaniesRef.current = companies;
            setItemsListCompaniesVersion(v => v + 1);
        }

        return companies;
    }, []);



    return (
        <UserContext.Provider value={{
            userContext,
            setUserContext,
            getCompaniesFromItems,
            itemsListCompanies: itemsListCompaniesRef.current,
            itemsListCompaniesVersion
        }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => useContext(UserContext);